import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { get } from 'lodash';

import { fetchLoansIfNeeded, fetchLoans } from '../../actions/loans';
import { mapLoans } from '../../reducers/loansReducer';
import EditPanel from './EditPanel';

const ObjectsonLoan = ({
  loaded,
  dispatch,
  showErrorMessage,
  errorMessage,
  loansData,
  EmployeeMasterID,
}) =>
  (<EditPanel
    title={<FormattedMessage id="loan.title" />}
    emptyText="loan.empty"
    loaded={loaded}
    showErrorMessage={showErrorMessage}
    errorMessage={errorMessage}
    onOpen={() => dispatch(fetchLoansIfNeeded())}
    modelName="EmployeeMasterObjectOnLoan"
    dataSource={loansData}
    mapModel={mapLoans}
    EmployeeMasterID={EmployeeMasterID}
    fetchData={fetchLoans}
  />);

const mapStateToProps = state => ({
  form: state.form.EmployeeMasterObjectOnLoan, // needed for EditPanel
  loaded: state.loansReducer.loaded,
  EmployeeMasterID: state.loginReducer.user.EmployeeMasterID,
  loansData: state.loansReducer.loansData,
  showErrorMessage: (state.loansReducer.error && state.loansReducer.error.Message.length) > 0,
  errorMessage: get(state.educationReducer, ['error', 'Message'], ''),
});

ObjectsonLoan.propTypes = {
  loaded: PropTypes.bool,
  dispatch: PropTypes.func.isRequired,
  loansData: PropTypes.array,
  showErrorMessage: PropTypes.bool,
  errorMessage: PropTypes.string,
  EmployeeMasterID: PropTypes.number,
};

export default connect(mapStateToProps)(ObjectsonLoan);



// WEBPACK FOOTER //
// ./src/components/profile/ObjectsonLoan.js